import { IPlayerState } from '../reducer.types';
import keyBy from 'lodash.keyby';
import { showApiRequestSuccess } from '../actions';

export const showApiRequestSuccessReducer = (
  state: IPlayerState,
  action: ReturnType<typeof showApiRequestSuccess>,
) => {
  const { data, trackId } = action.payload;

  const track = trackId ? state.tracksById?.[trackId] : undefined;
  const trackIsInPayload = data.tracks?.find(({ id }) => id === trackId);

  const showTracks = track && !trackIsInPayload ? [track, ...data.tracks] : data.tracks;

  return {
    ...state,
    showActionPayload: data,
    isShowApiRequestPending: false,
    showApiRequestErrorMessage: '',
    tracksById: {
      ...state.tracksById,
      ...keyBy(showTracks, 'id'),
    },
    tracksIdsOrdered: showTracks?.map((track) => track.id) ?? [],
  };
};
